<template>
  <div class="rule-error-log-view">
    <error-logs :rule="rule" wait-for-rule />
  </div>
</template>

<script>
import ErrorLogs from '@/ui/components/ErrorLogs.vue';

export default {
  name: 'RuleErrorLogView',
  components: {
    ErrorLogs,
  },
  inject: [ 'ruleView' ],
  computed: {
    rule() {
      return this.ruleView.rule;
    },
  },
};
</script>
